// Row 200 step 3 (vault #368): every confirmed agent status change is posted
// to /presence {type:"status"} so time per status (Break, Lunch, Meeting,
// Training, ...) can be reported. Notes for Meeting/Training ride along.
// Never billed. Best effort: a failed post is not retried.
import { useEffect, useRef } from 'react';
import { useContact } from '../context/ContactContext';
import { apiHeaders } from '../lib/consoleApi';
import { presenceUrl } from '../lib/awayGuard';
import { statusLogBody, shouldLogStatus } from '../lib/agentStatuses';

const PRESENCE_URL = presenceUrl(import.meta.env.VITE_DATA_URL || '');

export function useStatusLog() {
  const { agentStatus, agentConnected, statusNote, isDemo } = useContact();
  const lastLogged = useRef(null);
  useEffect(() => { if (!agentConnected) lastLogged.current = null; }, [agentConnected]);
  useEffect(() => {
    if (isDemo || !PRESENCE_URL) return;
    if (!shouldLogStatus({ connected: agentConnected, status: agentStatus, lastLogged: lastLogged.current })) return;
    lastLogged.current = agentStatus;
    const body = statusLogBody(agentStatus, statusNote);
    (async () => {
      try {
        const headers = await apiHeaders({ 'Content-Type': 'application/json' });
        if (!headers.Authorization) return;
        await fetch(PRESENCE_URL, { method: 'POST', headers, body: JSON.stringify(body) });
      } catch { /* best effort */ }
    })();
  }, [agentStatus, agentConnected, statusNote, isDemo]);
}
